module.exports = __webpack_public_path__ + "img/设置.b47b178e.svg";